import React from "react";

/**
 * Full-bleed hero artwork — “PAVE YOUR WAY TO SUCCESS”.
 * Photo composite: wooden-block staircase, a hand placing the next step,
 * and an ink-sketch professional climbing upward (matches the original brand art).
 */
export default function HeroArt() {
  return (
    <img
      className="student-hero__art"
      src="/home-hero.jpg"
      alt=""
      aria-hidden="true"
      draggable="false"
      decoding="async"
      fetchpriority="high"
    />
  );
}
